/**
 * ScrollToTop — resets the scroll position of the main `<Outlet />` container
 * (and window) on every route change so tabs/pages always open at the top,
 * never mid-scroll. Used inside the react-router hierarchy (must live under
 * <BrowserRouter>). Renders nothing.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        // Prefer scrolling the dashboard main container, fallback to window.
        const main = document.querySelector("main");
        if (main) main.scrollTo({ top: 0, left: 0, behavior: "auto" });
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);
    return null;
}
